import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
interface Props {
  participants: number
  respondents: number
  score: number
  scoreDescription: string
  showMaxScore?: boolean
}

const AnalyticsDescription = ({
  participants,
  respondents,
  score,
  scoreDescription,
  showMaxScore = false,
}: Props) => {
  return (
    <Box className={'_AnalyticsDescription_score'}>
      <Box className={'_AnalyticsDescription_scoreHeader'}>
        <span>{score}</span>
        {showMaxScore && <span className={'_AnalyticsDescription_maxScore'}>/10</span>}
      </Box>
      <span>{scoreDescription}</span>
      {!!participants && (
        <Box gap="s4" flexDirection="row">
          <span>{i18n.t('engagement_insights.survey_widget.analytics.participation')}</span>
          <span className={'_AnalyticsDescription_participation'}>
            {respondents}/{participants}
          </span>
        </Box>
      )}
    </Box>
  )
}

export default AnalyticsDescription
